import { RouteEnum } from '../enums/enums';

export const navigationLinks = [
  { name: 'Main Page', href: RouteEnum.Main },
  { name: 'Action (set A)', href: RouteEnum.Action1 },
  { name: 'Action (set B)', href: RouteEnum.Action2 },
  { name: 'Action (set C)', href: RouteEnum.Action3 },
  { name: 'Adjective', href: RouteEnum.Adjective },
  { name: 'Clothes', href: RouteEnum.Clothes },
  { name: 'Emotions', href: RouteEnum.Emotions },
  { name: 'Animal (set A)', href: RouteEnum.Animal1 },
  { name: 'Animal (set B)', href: RouteEnum.Animal2 },
  { name: 'Statistics', href: RouteEnum.Statistics },
];

export const DEFAULT_ACTIVE_ROW = {
  title: 'Word',
  direction: true,
};
